import { Container, ContainerProps } from '@hover/blueprint';
import React from 'react';
import LogoListMobile from './LogoListMobile';
import LogoListDesktop from './LogoListDesktop';
import LogoListTablet from './LogoListTablet';

interface Props extends ContainerProps {}

const ContractorsLogoList: React.FC<Props> = ({ ...rest }) => (
  <Container maxW="1200px" mb={{ base: '80px', tablet: '160px' }} {...rest}>
    <LogoListMobile />
    <LogoListDesktop />
    <LogoListTablet />
  </Container>
);

export default ContractorsLogoList;
